import Vue from "vue";
import linkDirective from "~/directives/linkDirective";
import isOneStop from "~/mixins/isOneStop";
import ASelect from "../components/a-select.vue";
import Application from "../components/application.vue";
import Button from "../components/button.vue";
import Date from "../components/date.vue";
import DatePicker from "../components/datePicker.vue";
import ExpandableTextarea from "../components/expandableTextarea.vue";
import Flash from "../components/flash/flash.vue";
import Column from "../components/grid/column.vue";
import Matrix from "../components/grid/matrix.vue";
import Row from "../components/grid/row.vue";
import RowGroup from "../components/grid/rowGroup.vue";
import SelectFilter from "../components/grid/selectFilter.vue";
import SecondaryHeader from "../components/header/secondaryHeader.vue";
import HelpTooltip from "../components/helpTooltip.vue";
import Icon from "../components/icon.vue";
import LinkOr from "../components/linkOr.vue";
import Loading from "../components/loading.vue";
import Modal from "../components/modal.vue";
import NumberInput from "../components/numberInput.vue";
import ControlGroup from "../components/panelBlock/controlGroup.vue";
import Pen from "../components/pen.vue";
import Pill from "../components/pill.vue";
import RequiredIndicator from "../components/required-indicator.vue";
import ScrollArea from "../components/scrollArea.vue";
import SearchInput from "../components/searchInput.vue";
import SecretInput from "../components/secretInput.vue";
import ToggleArrow from "../components/toggleArrow.vue";
import TooltipAlert from "../components/tooltip-alert.vue";
import Xpinner from "../components/xpinner.vue";
import cTooltipDirective from "../directives/cTooltipDirective";
import focusDirective from "../directives/focusDirective";
import focusTrapDirective from '~/directives/focusTrapDirective'
import ModalController from "../mixins/modalController";
import FeatureService from "../services/featureService";
import QuickJumpService from "../services/quickJumpService";
import { datadogRum } from '@datadog/browser-rum'
import Storager from "~/services/storager";
import stickyScrollBarDirective from "~/directives/stickyScrollBarDirective"
import stickyHeaderDirective from "~/directives/stickyHeaderDirective"


//------------------------ Directives
Vue.directive('tooltip', cTooltipDirective);
Vue.directive('focus', focusDirective);
Vue.directive('focus-trap', focusTrapDirective);
Vue.directive('visible', function(el, binding) {
  el.style.visibility = !!binding.value ? 'visible' : 'hidden';
});
Vue.directive('link', linkDirective)
Vue.directive('sticky-scrollbar', stickyScrollBarDirective);
Vue.directive('sticky-header', stickyHeaderDirective);


//------------------------ Components
Vue.component("application", Application);
Vue.component("secondary-header", SecondaryHeader);
Vue.component("a-select", ASelect);
Vue.component("expandable-textarea", ExpandableTextarea);
Vue.component("number-input", NumberInput);
Vue.component("secret-input", SecretInput);
Vue.component("search-input", SearchInput);
Vue.component("help-tooltip", HelpTooltip);
Vue.component("icon", Icon);
Vue.component("date", Date);
Vue.component("scroll-area", ScrollArea);
Vue.component("pill", Pill);
Vue.component("toggle-arrow", ToggleArrow);
Vue.component("control-group", ControlGroup);
Vue.component("row", Row);
Vue.component("column", Column);
Vue.component("row-group", RowGroup);
Vue.component("select-filter", SelectFilter);
Vue.component("required-indicator", RequiredIndicator);
Vue.component("matrix", Matrix);
Vue.component("flash", Flash);
Vue.component("date-picker", DatePicker);
Vue.component("xpinner", Xpinner);
Vue.component("modal", Modal);
Vue.component("pen", Pen);
Vue.component("btn", Button);
Vue.component("loading", Loading);
Vue.component("tooltip-alert", TooltipAlert);
Vue.component("link-or", LinkOr)

//------------------------ Mixins
Vue.mixin(ModalController);
Vue.mixin(isOneStop)
Vue.mixin({
  methods: {
    bubbleNativeEvent(event): void {
      this.$emit(event.type, event);
    }
  }
});


//------------------------ Alias
Vue.component("pencil", Vue.extend({
  props: {
    mode: {
      default: 'pencil'
    }
  },
  extends: Pen
}));

Vue.component("crayon", Vue.extend({
  props: {
    mode: {
      default: 'crayon'
    }
  },
  extends: Pen
}));

Vue.component("typewriter", Vue.extend({
  props: {
    mode: {
      default: 'typewriter'
    }
  },
  extends: Pen
}));

Vue.component("row-layout", Vue.extend({
  props: {
    additionalClass: {
      default: 'layout'
    }
  },
  extends: Row}));

// bootstrap // grid
Vue.component("b-row", Vue.extend({
  props: {
    type: {
      default: 'bootstrap'
    }
  },
  extends: Row
}));

Vue.component("b-column", Vue.extend({
  props: {
    type: {
      default: 'bootstrap'
    }
  },
  extends: Column
}));

// table // grid
Vue.component("t-row", Vue.extend({
  props: {
    tableElement : {
      default: true
    }
  },
  extends: Row
}));

Vue.component("t-column", Vue.extend({
  props: {
    tableElement : {
      default: true
    }
  },
  extends: Column
}));

Vue.component("t-prefix", Vue.extend({
  props: {
    type: {
      default: 'prefix'
    },
    tableElement : {
      default: true
    }
  },
  extends: Column
}));

Vue.component("t-suffix", Vue.extend({
  props: {
    type: {
      default: 'suffix'
    },
    tableElement : {
      default: true
    }
  },
  extends: Column
}));

// grid
Vue.component("prefix", Vue.extend({
  props: {
    type: {
      default: 'prefix'
    }
  },
  extends: Column
}));

Vue.component("suffix", Vue.extend({
  props: {
    type: {
      default: 'suffix'
    }
  },
  extends: Column
}));

Vue.component("multi-input", Vue.extend({
  props: {
    multiInput: {
      default: true
    }
  },
  extends: Row
}));

Vue.component("square-tag", Vue.extend({
  props: {
    multiInput: {
      default: true
    },
    squareTag: {
      default: true
    }
  },
  extends: Row
}));

Vue.component("toggle-select", Vue.extend({
  props: {
    isSearchable: {
      default: false
    },
    options: {
      default: () => {
        return [
          {label: 'No', value: false},
          {label: 'Yes', value: true}
        ]
      }
    }
  },
  mounted(): void {
    if (this.value === null) {
      this.$emit('input', this.options[0].value);
    }
  },
  extends: ASelect
}));

//------------------------ Plugins
Vue.use(QuickJumpService)
Vue.use(FeatureService)

const storager = new Storager('formability:features')
const features = storager.get

if (features?.rum?.development || features?.rum?.production) {
  datadogRum.init({
    applicationId: '94cdce0f-fc36-4e4e-9c64-b76813156f5d',
    clientToken: 'pubf8e1d1c6d49d47c099c6400536d285a0',
    site: 'datadoghq.com',
    env: window.formability_environment || 'local',
    service:'formability',
    sampleRate: 100,
    trackInteractions: true
  })
}